import { Component, OnInit } from '@angular/core';
import {User} from "../../shared/models/user";
import {UserService} from "../../shared/services/user.service";
import {ActivatedRoute, Router} from '@angular/router';
import { AlertService } from 'app/shared/services/alert.service';

@Component({
  selector: 'app-user-delete',
  templateUrl: './user-delete.component.html',
  styleUrls: ['./user-delete.component.css']
})
export class UserDeleteComponent implements OnInit {

  private _reassignClientsUser:User;
  private _userToDelete:User;
  private _userFilterFunction:(user:User) => boolean;
  private _users:User[];

  constructor(private userService:UserService, 
    private route:ActivatedRoute, private alertService:AlertService, private router:Router) { 
    this._userToDelete = new User();
    this._userFilterFunction = this.filterUserToDelete.bind(this);
    this._users = [];
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      let userId = params['userId'];
      this.userService.getUser(userId).then(user => {
        this._userToDelete = user;
      });
    });
  }

  public get Users() {
    return this._users;
  }
  
  private filterUserToDelete(user:User) {
    return user.id != this._userToDelete.id;
  }
  public get filterUser() {
    return this._userFilterFunction
  }

  public get User() {
    return this._userToDelete;
  }
  public set UserToAssign(v:User) {
    this._reassignClientsUser = v;
  }
  public get UserToAssign() {
    return this._reassignClientsUser;
  }
  public setUserToAssign(user:User) {
    this._reassignClientsUser = user;
  }
  public delete() {
    // this.userService.deleteUser(this._userToDelete, this._reassignClientsUser).then((result) => {
    //   this.alertService.success("User Deleted");
    //   this.router.navigate(["../../"], {replaceUrl: true, relativeTo: this.route});
    // })
    // .catch(error => {
    //   console.error(error);
    //   this.alertService.error("The user failed to delete.  Try again or contact support");
    // });
  }
}



// WEBPACK FOOTER //
// ./src/app/users/user-delete/user-delete.component.ts